import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { buildWordFrequency } from "./pmfUtils";
import CssWordCloud from "./CssWordCloud";

export default function PmfInsights({ responses }) {
    const { t } = useTranslation();

    const loveWords = useMemo(() => {
        const texts = responses.filter((r) => r.disappointment === "very_disappointed").map((r) => r.mainBenefit);
        return buildWordFrequency(texts);
    }, [responses]);

    const holdBackWords = useMemo(() => {
        const texts = responses.filter((r) => r.disappointment === "somewhat_disappointed").map((r) => r.improvement);
        return buildWordFrequency(texts);
    }, [responses]);

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl border border-slate-200 p-6">
                    <div className="flex items-center gap-2 mb-1">
                        <div className="w-2 h-2 rounded-full bg-green-500" />
                        <h3 className="text-sm font-semibold text-slate-900">{t("survey.admin.ins.love")}</h3>
                    </div>
                    <p className="text-xs text-slate-400 mb-3">{t("survey.admin.ins.loveDesc")}</p>
                    <CssWordCloud words={loveWords} />
                </div>
                <div className="bg-white rounded-xl border border-slate-200 p-6">
                    <div className="flex items-center gap-2 mb-1">
                        <div className="w-2 h-2 rounded-full bg-amber-500" />
                        <h3 className="text-sm font-semibold text-slate-900">{t("survey.admin.ins.holdsBack")}</h3>
                    </div>
                    <p className="text-xs text-slate-400 mb-3">{t("survey.admin.ins.holdsBackDesc")}</p>
                    <CssWordCloud words={holdBackWords} />
                </div>
            </div>
            <div className="bg-blue-50 rounded-xl border border-blue-200 p-5">
                <h4 className="text-sm font-semibold text-blue-900 mb-1">{t("survey.admin.ins.guidanceTitle")}</h4>
                <p className="text-sm text-blue-700">{t("survey.admin.ins.guidance")}</p>
            </div>
        </div>
    );
}
